export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14567.46e7f537.jpg";